module.exports = __webpack_public_path__ + "media/images/shop/shop-cover-8703bc6dcf2bdb607c36453e4a1ba7f4.jpg";